import { I18N } from 'aurelia-i18n';
import { EventAggregator } from 'aurelia-event-aggregator';
import { BindingSignaler } from 'aurelia-templating-resources';
import { autoinject, observable } from 'aurelia-framework';
import { applicationLogger } from "../logging/logger";
import * as Enumerable from "linq-es2015";
import { MeasurementSystemEvents } from "../events/measurement-system-events";
import { MeasurementSystems } from "../converters/measurement-systems";

@autoinject
export class MeasurementSystemSelector {
 
	private readonly i18N: I18N;
	private readonly bindingSignaler: BindingSignaler;
	private readonly eventAggregator: EventAggregator;
	private systems: any[];
	@observable selectedSystem: any;

	constructor(bindingSignaler: BindingSignaler, eventAggregator: EventAggregator) {

		this.bindingSignaler = bindingSignaler;
		this.eventAggregator = eventAggregator;
		this.configureSystems();
		this.selectedSystem = this.getSelectedSystem();
		applicationLogger.debug("Selected system: " + this.selectedSystem);
	}

	getSelectedSystem() {
		let system = localStorage.getItem("measurement-system");
		if (!system) {
			system = MeasurementSystems.imperial;
		}
		return this.getSystem(system);
	}

	getSystem(name: string) {
		const enumerable = Enumerable.AsEnumerable(this.systems);
		return enumerable.FirstOrDefault(system => system.name === name);
	}

	selectedSystemChanged() {
		localStorage.setItem("measurement-system", this.selectedSystem.name);
		this.eventAggregator.publish(MeasurementSystemEvents.measurementSystemChanged, this.selectedSystem.name);
	}

	configureSystems() {
		this.systems = [
			{ name: MeasurementSystems.imperial },
			{ name: MeasurementSystems.metric }
		];
	};

}

